import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mf-chrome-support',
  templateUrl: './mf-chrome-support.component.html',
  styleUrls: ['./mf-chrome-support.component.css']
})
export class MfChromeSupportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
